const config = {
    "title": "CHA Publications",
    "appKey": "eb829b2a-6b47-46e9-a5f6-f0e901388cbc",
    "stripeKey": "pk_test_W955SArBKQSl0oJiqvTy1RpK002fHGREqC",
    "host": "https://graphql.canvasflow.io",
    "theme": {
        "toc": {
            "background": "#f8f8f8",
            "color": "#000000",
            "selectedColor": "#000000",
            "textTransform": "none",
            "listStyle": "none",
            "fontFamily": "",
            "selectedFontFamily": "",
            "thumbnails": {
                "enabled": true
            }
        },
        "color": "#ffffff",
        "background": "#ffffff",
        "loading": {
            "color": "#333333",
            "type": false
        },
        "progressBar": {
            "background": "#ffffff",
            "color": "#666666",
            "enabled": true,
            "height": 5
        },
        "navbar": {
            "height": 50,
            "background": "#ffffff",
            "color": "#fff",
            "slider": {
                "background": "#ededed",
                "accentColor": "#b9b9b9",
                "color": "#b9b9b9",
                "knob": {
                    "size": 25,
                    "color": "#000000"
                }
            },
            "toc": {
                "color": "#666666",
                "selectedColor": "#333333",
                "textTransform": "none",
                "listStyle": "none",
                "fontFamily": "",
                "selectedFontFamily": ""
            }
        },
        "buttons": {
            "primary": {
                "color": "#ffffff",
                "background": "#28a745"
            },
            "secondary": {
                "color": "#ffffff",
                "background": "#6c757d"
            }
        },
        "ribbons": {
            "display": true
        },
        "issues": {
            "title": {
                "display": true
            }
        },
        "bottomBar": {
            "background": "#343a40",
            "accentColor": "#f8f9fa",
            "color": "#ffffff",
            "slider": {
                "background": "#555555",
                "accentColor": "#23ad21",
                "color": "#555555",
                "knob": {
                    "size": 25,
                    "color": "#000000"
                }
            }
        }
    },
    "version": "1.23.3",
    "auth": {
        "google": true,
        "apple": true,
        "email": true
    },
    "password": {
        "enabled": false,
        "value": ""
    },
    "rssFeed": {
        "enabled": false
    },
    "search": {
        "enabled": false
    },
    "lastLocation": {
        "enabled": false
    },
    "tts": {
        "enabled": false
    },
    "admin": {
        "enabled": true
    },
    "iframe": {
        "enabled": false
    },
    "bookmarks": {
        "enabled": false
    },
    "readTime": {
        "enabled": false
    },
    "indexing": {
        "enabled": false
    },
    "share": {
        "enabled": true
    },
    "subdirectory": "",
    "contentProtection": {
        "enabled": false
    },
    "navArrows": {
        "enabled": true,
        "mode": "automatic"
    },
    "fontSizeOption": {
        "enabled": true
    },
    "defaultLanguage": "en",
    "languages": [
        "en"
    ],
    "analytics": {
        "google": {
            "trackerID": "GTM-WGS8D47",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "GTM-WGS8D47",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": "GTM-WGS8D47"
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    },
    "contentType": "responsive"
};
window.appKey = 'eb829b2a-6b47-46e9-a5f6-f0e901388cbc';
window.version = '1.23.3';
window.config = config;
export default config;